import { subMonths, endOfMonth } from 'date-fns';

export const convertToUTCDateOnly = (date: Date): string => {
  // Crée une nouvelle date en UTC avec l'heure réglée à minuit
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  // Convertir en chaîne ISO et extraire uniquement la partie date (AAAA-MM-JJ)
  const utcDateOnly = utcDate.toISOString().split('T')[0];

  return utcDateOnly;
};
export const convertToUTCDateOnlyDate = (date: Date): Date => {
  // Crée une nouvelle date en UTC avec l'heure réglée à minuit
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  // Convertir en chaîne ISO et extraire uniquement la partie date (AAAA-MM-JJ)
  const utcDateOnly = utcDate.toISOString().split('T')[0];

  return new Date(utcDateOnly);
};
// Extraction de la partie du siren et date AN de fichier
export function extractPartsAndConvertDate(input: string): [string, Date | null] | null {
  const regex = /^(.*?)FEC(\d{4})/;
  const match = input.match(regex);
  if (match) {
    const siren = match[1];
    const yearString = match[2];

    const year = parseInt(yearString, 10);
    const date = new Date(year, 0, 1);

    return [siren, date];
  }
  return null;
}

export const getDefaultStartDate = (): Date => {
  const currentYear = new Date().getFullYear();
  return new Date(currentYear, 0, 1); // January 1er
};

export const getDefaultEndDate = (startDate: Date): Date => {
  return new Date(startDate.getFullYear(), 11, 31); // December 31
};
export const lastDayOfLastMonth = (): Date => {
  const dateToday = new Date();
  const lastMonth = subMonths(dateToday, 1);
  return endOfMonth(lastMonth);
};
/**
 * @function formatDateShort
 * @description Formate une date (au format string) en JJ/MM (ex: "24/07")
 * @param dateStr Chaîne représentant une date (ex: "2025-07-24")
 * @returns La date formatée en chaîne "JJ/MM"
 */
export const formatDateShort = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
export const formatDate = (date: Date): string => {
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatTodayDate = (): string => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
